export const THEME_STORAGE_KEY = 'tresor_theme_pref';

export function getThemePreference() {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
    return 'auto';
  } catch {
    return 'auto';
  }
}

export function resolveTheme(pref) {
  if (pref === 'light' || pref === 'dark') return pref;
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

export function applyTheme(pref) {
  // Eingebettet bestimmt das Dashboard das Farbschema (siehe embed.js).
  const fromParent = document.documentElement.getAttribute('data-parent-theme');
  document.documentElement.setAttribute('data-vault-theme', fromParent || resolveTheme(pref));
}

/** Public/marketing pages: always follow OS light/dark setting. */
export function applySystemTheme() {
  applyTheme('auto');
}

export function setThemePreference(pref) {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, pref);
  } catch {
    /* ignore */
  }
  applyTheme(pref);
}

/** Vault/auth: use stored preference (default auto = system). */
export function applyUserTheme() {
  applyTheme(getThemePreference());
}

/**
 * Re-apply when OS theme changes.
 * @param {{ forceSystem?: boolean }} options — forceSystem: public pages ignore manual override
 */
export function subscribeToSystemTheme(options = {}) {
  const { forceSystem = false } = options;
  const mq = window.matchMedia('(prefers-color-scheme: light)');
  const onChange = () => {
    if (forceSystem) {
      applySystemTheme();
    } else if (getThemePreference() === 'auto') {
      applyUserTheme();
    }
  };
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
}
